<template>
    <div class="commdityRight">
        <div class="title clearfix">
             <el-tabs v-model="activeName" class="tabs" @tab-click="handleClick" type="card">
                <el-tab-pane label="默认" name="default"></el-tab-pane>
                <!--<el-tab-pane :label="'销量 ' + salesVolumeSort" name="click_count"></el-tab-pane>
                <el-tab-pane :label="'人气 ' + popularitySort" name="sales_sum"></el-tab-pane>-->
            </el-tabs>
            <div class="count">共 <b class="colorBlue">{{count}}</b> 个商品</div>
        </div>
        <div class="content">
            <transition-group name="scale">
                <div class="item" v-for="(item) in prop" :key="item.goods_id">
                    <router-link :to="'/goodDetail/'+item.goods_id" target="_blank" class="clearfix">
                        <div class="imgBox tc">
                            <img :src="item.original_img | thumbnailUrl" />
                        </div>
                        <!--<p class="price">￥{{ item.market_price }}</p>-->
                        <p class="name colorBlue">{{ item.common_name }}<em v-if="item.goods_name!==''" style="font-style: normal">({{ item.goods_name }})</em></p>
                        <p>规格：{{ item.goods_spec }}</p>
                        <p>厂商：{{ item.manufacturer_name }}</p>
                        <!--<p>采购价：<span class="colorRed" v-text="item.wholesale_price==='登录可见'?'登录可见':'￥'+ item.wholesale_price" style="border:none;display:inline"></span></p>-->
                    </router-link>
                </div>
            </transition-group>
            <div class="no-data" v-if="prop.length<1">暂无数据</div>
        </div>
        <!-- <div>{{ tab }}</div> -->
    </div>
</template>

<script>
export default {
    props: ['prop', 'sort', 'count'],
    data() {
        return {
            activeName: 'default',
        }
    },
    computed: {
        tab() {
            return this.$store.getters.commdityQuery.tab
        },
        salesVolumeSort() {
            return this.activeName === 'click_count' && this.sort === 'desc' ? '↓' : '↑';
        },
        popularitySort() {
            return this.activeName === 'sales_sum' && this.sort === 'desc' ? '↓' : '↑';
        }
    },
    methods: {
        handleClick(tab) {
            this.activeName = tab.name;
            this.$emit('change', tab.name);
        },
        toDetail(item) {
            this.$router.push(`/goodDetail/${item.goods_id}`);
        }
     }
}
</script>

<style lang="scss" scoped>
    .commdityRight{
        .title{
            width: 960px;
            background: #f5f2f2;
            height: 55px;
            // display: flex;
            // justify-content: space-between;
            line-height: 55px;
            overflow: hidden;
            font-size: 14px;
            .el-tabs__item{
                background: #fff;
            }
            .tabs {
                float: left;
            }
            .count {
                float: right;
                margin-right: 20px;
            }
        }
        .no-data{
            font-size: 20px;
            width: 100%;
            margin: 0 auto;
            text-align: center;
            margin-top: 100px;
            margin-bottom: 100px;
        }
    }
    .content span{
        display: flex;
        flex-wrap: wrap;
        border: 1px solid #eee;
        .item {
            min-height: 250px;
            background: #fff;
            margin:5px 0;
            padding: 15px;
            border-radius: 6px;
            font-size: 12px;
            border:1px solid transparent;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 195px;
            cursor: pointer;
            p {
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .name {
                color:#1d90d0;
            }
            .price {
                color: red;
                font-size: 18px;
            }
            .imgBox {
                margin-bottom: 6px;
                img{
                    border-radius: 8px;
                    width: 195px;
                    height: 195px;
                    object-fit: contain;
                }
            }
            .button {
                margin: 0 auto;
                display: block;
                margin-top: 6px;
            }
            &:hover {
                border-color: #70cdff;
                box-shadow: 0px 5px 8px 1px rgba(0, 78, 97, 0.103);
                transition: 200ms;
            }
        }
    }
    
</style>
<style lang="scss">
    .commdityRight{
        .title{
            .el-tabs__item{
                background: #fff;
                margin-left: 10px;
                height: 30px;
                line-height: 30px;
            }
            .el-tabs__item:first-child{
                margin-left: 40px;
            }
            .el-tabs__item.is-active{
                background: #1d90d0;
                color: #fff;
            }
            .el-tabs__header{
                margin: 0;
            }
        }
        
    }
    .scale-enter-active, .scale-leave-active {
        transition: all .2s;
    }
    .scale-enter, .scale-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: scale(0.7);
    }
    .item p {
        white-space: nowrap;
    }
</style>